var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from "aurelia-dependency-injection";
import { LookupValueRequest, OrderByEnum } from "../../../../models/lookups/lookup.models";
import { DataType } from "../../../../models/queries/queries.models";
import { NotificationClientService, NotificationType } from "../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import { TokenClient } from "../../../../services/authentication/token-client.service";
import { BillingClientService } from "../../../../services/modules/billing-client.service";
import { LookupClientService } from "../../../../services/lookups/lookup-client.service";
import { Router } from "aurelia-router";
import { RouterConstants } from "../../../../configuration/router.constants";
import moment from "moment";
import { CacheClient, CacheLocation } from "../../../../services/basics/client-caching.service";
import { ConfigurationService } from "../../../../services/basics/configuration.service";
import { RequestConstants } from "../../../../configuration/request.constants";
import * as _ from "lodash";
import { computedFrom } from "aurelia-binding";
var GlobalBilling = /** @class */ (function () {
    function GlobalBilling(notificationService, i18N, lookupService, configurationService, billingService, tokenClient, router, cacheClient) {
        this.notificationService = notificationService;
        this.i18N = i18N;
        this.lookupService = lookupService;
        this.configurationService = configurationService;
        this.billingService = billingService;
        this.tokenClient = tokenClient;
        this.router = router;
        this.cacheClient = cacheClient;
        this._selectedBrandId = null;
        this._selectedOperatorId = null;
        this._selectedAccountingPeriodId = null;
        this._selectedLotteryId = null;
        this.isTotalsLoading = false;
        this.isReadonly = false;
        this.allowAccountingPeriodEdit = false;
        this.operatorTopups = [];
        this.operatorTopupsTotal = 0;
        this.brandTopups = [];
        this.brandTopupsTotal = 0;
        this.reloadData = this.getReloadDataDebounced();
        this.activatedOnce = false;
    }
    Object.defineProperty(GlobalBilling.prototype, "selectedBrandName", {
        get: function () {
            return this.selectedBrand ? this.selectedBrand.name : "";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GlobalBilling.prototype, "selectedBrandId", {
        get: function () {
            return this._selectedBrandId;
        },
        set: function (value) {
            if (this._selectedBrandId == value)
                return;
            this._selectedBrandId = value;
            this.reloadData();
            this.cacheClient.put("selected-brand", this._selectedBrandId, CacheLocation.LocalStorage);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GlobalBilling.prototype, "selectedOperatorId", {
        get: function () {
            return this._selectedOperatorId;
        },
        set: function (value) {
            if (this._selectedOperatorId == value)
                return;
            this._selectedOperatorId = value;
            this.loadBrands(this._selectedOperatorId);
            this.reloadData();
            this.cacheClient.put("selected-operator", this._selectedOperatorId, CacheLocation.LocalStorage);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GlobalBilling.prototype, "selectedAccountingPeriodId", {
        get: function () {
            return this._selectedAccountingPeriodId;
        },
        set: function (value) {
            if (this._selectedAccountingPeriodId == value)
                return;
            this._selectedAccountingPeriodId = value;
            this.reloadData();
            this.cacheClient.put("selected-accounting-period", this._selectedAccountingPeriodId, CacheLocation.LocalStorage);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GlobalBilling.prototype, "selectedLotteryId", {
        get: function () {
            return this._selectedLotteryId;
        },
        set: function (value) {
            if (this._selectedLotteryId == value)
                return;
            this._selectedLotteryId = value;
            this.reloadData();
            this.cacheClient.put("selected-lottery", this._selectedLotteryId, CacheLocation.LocalStorage);
        },
        enumerable: false,
        configurable: true
    });
    GlobalBilling.prototype.attached = function () {
        var _this = this;
        var brandPromise = this.cacheClient.get("selected-brand", CacheLocation.LocalStorage);
        var operatorPromise = this.cacheClient.get("selected-operator", CacheLocation.LocalStorage);
        var accountingPeriodPromise = this.cacheClient.get("selected-accounting-period", CacheLocation.LocalStorage);
        var lotteryPromise = this.cacheClient.get("selected-lottery", CacheLocation.LocalStorage);
        Promise.all([brandPromise, operatorPromise, accountingPeriodPromise, lotteryPromise]).then(function (response) {
            _this.selectedBrandId = response[0];
            _this._selectedOperatorId = response[1];
            _this._selectedAccountingPeriodId = response[2];
            _this._selectedLotteryId = response[3];
            if (!_this.activatedOnce)
                _this.onActivated();
        });
    };
    Object.defineProperty(GlobalBilling.prototype, "cleanOperatorName", {
        get: function () {
            return this.selectedOperator ? this.selectedOperator.name.replace("Operator", "") : "";
        },
        enumerable: false,
        configurable: true
    });
    GlobalBilling.prototype.operatorChanged = function (event) {
        this.selectedOperator = event.detail.item;
    };
    GlobalBilling.prototype.brandChanged = function (event) {
        this.selectedBrand = event.detail.item;
    };
    GlobalBilling.prototype.onActivated = function () {
        var _this = this;
        this.activatedOnce = true;
        var request = new LookupValueRequest();
        request.setOverrideMetaDataFiltering(OrderByEnum.IDDSC);
        request.lookupValueQuery = "AccountingPeriods";
        this.lookupService.getLookup(request).then(function (x) {
            _this.accountingPeriods = x.values;
            _this.accountingPeriods.splice(0, 0, {
                id: -1,
                name: "All"
            });
        });
        request = new LookupValueRequest();
        request.lookupValueQuery = "Lotteries";
        request.setOverrideMetaDataFiltering(OrderByEnum.NameASC);
        this.lookupService.getLookup(request).then(function (x) {
            _this.lotteries = x.values;
            _this.lotteries.splice(0, 0, {
                id: -1,
                name: "All"
            });
        });
        if (this.tokenClient.isSuperAdmin()) {
            request = new LookupValueRequest();
            request.lookupValueQuery = "Operators";
            request.setOverrideMetaDataFiltering(OrderByEnum.NameASC);
            this.lookupService.getLookup(request).then(function (x) {
                _this.operators = x.values;
            });
            this.loadBrands(null);
        }
        this.reloadData();
    };
    GlobalBilling.prototype.loadBrands = function (_selectedOperatorId) {
        var _this = this;
        var request = new LookupValueRequest();
        request.lookupValueQuery = "Brands";
        request.setOverrideMetaDataFiltering(OrderByEnum.NameASC);
        request.parameters = _selectedOperatorId ? _selectedOperatorId.toString() : "";
        this.lookupService.getLookup(request).then(function (x) {
            _this.brands = x.values;
            _this.brands.splice(0, 0, {
                id: -1,
                name: "All"
            });
        });
    };
    GlobalBilling.prototype.getReloadDataDebounced = function () {
        var debounceSettings = {
            leading: false,
            maxWait: 2000,
            trailing: true
        };
        return _.debounce(this.internalReloadData.bind(this), 2000, debounceSettings);
    };
    GlobalBilling.prototype.refreshData = function () {
        this.internalReloadData();
    };
    GlobalBilling.prototype.internalReloadData = function () {
        var _this = this;
        this.isTotalsLoading = true;
        this.operatorTopups = [];
        this.brandTopups = [];
        this.operatorTopupsTotal = 0;
        this.brandTopupsTotal = 0;
        this.billingService.getBilling(this.selectedBrandId > 0 ? this.selectedBrandId : null, this.selectedOperatorId > 0 ? this.selectedOperatorId : null, this.selectedLotteryId > 0 ? this.selectedLotteryId : null, this.selectedAccountingPeriodId > 0 ? this.selectedAccountingPeriodId : null)
            .then(function (response) {
            _this.isTotalsLoading = false;
            if (response.claims) {
                _this.totalInsuranceClaims = response.claims.totalInsurancePayout;
                _this.totalInsurancePolicyDeduction = response.claims.totalInsurancePayoutPolicyDeduction;
                _this.totalClaimBrandPayout = response.claims.totalBrandPayout;
                _this.totalFxDifference = response.claims.totalFxDifference;
            }
            _this.totalRevenue = response.postingTotal.totalTicketPriceInEuro;
            _this.totalCost = response.postingTotal.totalTicketCost;
            _this.totalCostAdjustment = response.adjustmentTotal.totalDifferenceInCosts;
            _this.totalProfit = _this.totalRevenue - (_this.totalCost + _this.totalCostAdjustment) - (_this.totalClaimBrandPayout ? _this.totalClaimBrandPayout : 0);
            _this.totalOperatorMargin = response.postingTotal.totalOperatorMargin + (response.adjustmentTotal.totalDifferenceInOperatorMargin * -1);
            _this.totalPlatformMargin = response.postingTotal.totalPlatformMargin + (response.adjustmentTotal.totalDifferenceInPlatformMargin * -1);
            _this.totalInsuranceMargin = response.postingTotal.totalInsuranceProfit + response.adjustmentTotal.totalInsuranceProfit;
            _this.totalInsuranceCost = response.postingTotal.totalInsuranceCost + (response.adjustmentTotal.totalDifferenceInCosts * -1);
            _this.totalPlatformProfit = _this.totalPlatformMargin + _this.totalInsuranceMargin;
            _this.agentsCommission = response.agentsCommission ? response.agentsCommission : 0;
            _this.agentFees = _this.agentsCommission;
            _this.referrerFees = response.referrerFees ? response.referrerFees : 0;
            _this.spinolaMargin = _this.totalPlatformMargin;
            _this.operatorMargin = _this.totalOperatorMargin;
            _this.brandMargin = (_this.totalProfit - _this.totalInsurancePolicyDeduction) - _this.referrerFees;
            _this.spinolaAmountToPayOperator = _this.totalCostAdjustment + _this.totalInsuranceCost + _this.referrerFees + _this.spinolaMargin;
            _this.brandCostOfSale = _this.totalInsuranceCost + _this.referrerFees + _this.spinolaMargin + _this.operatorMargin;
            _this.brandProfit = _this.totalRevenue - _this.brandCostOfSale - _this.agentFees;
            _this.operatorTopups = response && response.operatorTopups ? response.operatorTopups : [];
            _this.brandTopups = response && response.brandTopups ? response.brandTopups : [];
            _this.operatorTopupsTotal = response ? response.operatorTopupsTotal : 0;
            _this.brandTopupsTotal = response ? response.brandTopupsTotal : 0;
        }).catch(function (error) {
            _this.isTotalsLoading = false;
            _this.notificationService.show(_this.i18N.tr('error-text') + "!", _this.i18N.tr('error-loading-meta-data-for-query-editor-text'), NotificationType.Error);
        });
    };
    GlobalBilling.prototype.formatTopupDate = function (value) {
        return value ? moment(value).format("DD/MM/YYYY HH:mm") : "";
    };
    GlobalBilling.prototype.downloadExcel = function () {
        var _this = this;
        try {
            var odataUrl = "/odata/Billings/Genesis.DownloadBillingExcel(brandId=".concat(this.selectedBrandId && this.selectedBrandId > 0 ? this.selectedBrandId : 'null');
            odataUrl += ',operatorId=' + (this.selectedOperatorId && this.selectedOperatorId > 0 ? this.selectedOperatorId : 'null');
            odataUrl += ',lotteryId=' + (this.selectedLotteryId && this.selectedLotteryId > 0 ? this.selectedLotteryId : 'null');
            odataUrl += ',accountPeriodId=' + (this.selectedAccountingPeriodId && this.selectedAccountingPeriodId > 0 ? this.selectedAccountingPeriodId : 'null');
            odataUrl += ")";
            this.isDownloadingExcel = true;
            var self_1 = this;
            $.ajax({
                type: "GET",
                url: odataUrl,
                beforeSend: function (request) {
                    var headers = self_1.configurationService.getList(RequestConstants.ConfigurationTypes.RequestHeaders);
                    var keys = Object.keys(headers);
                    keys.forEach(function (key) {
                        request.setRequestHeader(key, headers[key].toString());
                    });
                },
                success: function (x) {
                    var link = document.createElement('a');
                    link.download = 'Billing.xlsx';
                    link.href = window.URL.createObjectURL(x);
                    link.click();
                    self_1.isDownloadingExcel = false;
                },
                error: function () {
                    _this.notificationService.show("Error", "Failed to export to excel", NotificationType.Error);
                    self_1.isDownloadingExcel = false;
                },
                xhr: function () {
                    var xhr = new XMLHttpRequest();
                    xhr.responseType = 'blob';
                    return xhr;
                }
            });
        }
        catch (exception) {
            this.notificationService.show(this.i18N.tr('Failed to export data to excel'), "", NotificationType.Error);
        }
    };
    GlobalBilling.prototype.getCommonColumns = function (isClaim) {
        if (isClaim === void 0) { isClaim = false; }
        var columns = [];
        columns.push({
            name: "gamePlayerTicketDrawId",
            title: "Ticket Id",
            dataType: DataType.Number,
            isHidden: false,
            isFilterable: true,
            isSortable: true,
            isGrouping: false,
            sortOrder: 0,
            groupOrder: 0,
            columnOrder: 0,
            isAscending: false
        });
        if (!isClaim)
            columns.push({
                name: "transactionDate",
                title: "Date",
                dataType: DataType.DateTime,
                isFilterable: true,
                isSortable: false,
                isGrouping: false,
                sortOrder: 1,
                groupOrder: 0,
                columnOrder: 0,
                valueConverter: function (date) { return moment(date).format("DD/MM/YYYY hh:mm"); },
                isAscending: false
            });
        columns.push({
            name: "lotteryId",
            title: "Lottery",
            dataType: DataType.Lookup,
            parameter: "lotteries",
            isHidden: false,
            isFilterable: true,
            isSortable: false,
            isGrouping: false,
            sortOrder: 0,
            groupOrder: 0,
            columnOrder: 2
        });
        if (!isClaim)
            columns.push({
                name: "ticketPrice",
                title: "Ticket Price in Euro",
                dataType: DataType.Number,
                isFilterable: true,
                isSortable: false,
                isGrouping: false,
                sortOrder: 0,
                groupOrder: 0,
                columnOrder: 3
            });
        //then it is an operator no need to show the operator column
        if (this.selectedBrandId) {
            columns.push({
                name: "brandId",
                title: "Brand",
                parameter: "brands",
                dataType: DataType.Lookup,
                isHidden: false,
                isFilterable: true,
                isSortable: false,
                isGrouping: false,
                sortOrder: 0,
                groupOrder: 0,
                columnOrder: 1
            });
        }
        return columns;
    };
    GlobalBilling.prototype.getBillingPostingColumns = function () {
        var columns = [
            {
                name: "drawDate",
                title: "Draw Date",
                dataType: DataType.Date,
                isHidden: false,
                isFilterable: true,
                isSortable: false,
                isGrouping: false,
                sortOrder: 0,
                groupOrder: 0,
                columnOrder: 3,
                valueConverter: function (date) { return moment(date).format("DD/MM/YYYY"); },
            },
            {
                name: "ticketCost",
                title: "Cost of Sale",
                dataType: DataType.Number,
                isHidden: false,
                isFilterable: true,
                isSortable: false,
                isGrouping: false,
                sortOrder: 0,
                groupOrder: 0,
                columnOrder: 4
            },
            {
                name: "ticketProfit",
                title: "Ticket Profit",
                dataType: DataType.Number,
                isHidden: false,
                isFilterable: true,
                isSortable: false,
                isGrouping: false,
                sortOrder: 0,
                groupOrder: 0,
                columnOrder: 4
            },
            {
                name: "isEstimate",
                title: "Is Estimate",
                dataType: DataType.Boolean,
                isHidden: false,
                isFilterable: true,
                isSortable: false,
                isGrouping: false,
                sortOrder: 0,
                groupOrder: 0,
                columnOrder: 9
            }
        ];
        if (this.isOperatorAdmin() || this.isAdmin()) {
            columns.push({
                name: "operatorMargin",
                title: "Operator Margin",
                dataType: DataType.Number,
                isHidden: false,
                isFilterable: true,
                isSortable: false,
                isGrouping: false,
                sortOrder: 0,
                groupOrder: 0,
                columnOrder: 5
            });
        }
        if (this.isAdmin()) {
            columns = columns.concat([{
                    name: "platformMargin",
                    title: "Platform Margin",
                    dataType: DataType.Number,
                    isHidden: false,
                    isFilterable: true,
                    isSortable: false,
                    isGrouping: false,
                    sortOrder: 0,
                    groupOrder: 0,
                    columnOrder: 6
                },
                {
                    name: "insuranceCost",
                    title: "Insurance Cost",
                    dataType: DataType.Number,
                    isHidden: false,
                    isFilterable: true,
                    isSortable: false,
                    isGrouping: false,
                    sortOrder: 0,
                    groupOrder: 0,
                    columnOrder: 7
                },
                {
                    name: "insuranceProfit",
                    title: "Insurance Margin",
                    dataType: DataType.Number,
                    isHidden: false,
                    isFilterable: true,
                    isSortable: false,
                    isGrouping: false,
                    sortOrder: 0,
                    groupOrder: 0,
                    columnOrder: 8
                },
                {
                    name: "adjustmentPeriodName",
                    title: "Adjusted in Period",
                    dataType: DataType.Default,
                    isHidden: false,
                    isFilterable: true,
                    isSortable: false,
                    isGrouping: false,
                    sortOrder: 0,
                    groupOrder: 0,
                    columnOrder: 9
                }
            ]);
        }
        return this.getCommonColumns().concat(columns);
    };
    GlobalBilling.prototype.getBillingAdjustmentColumns = function () {
        var columns = [
            {
                name: "drawDate",
                title: "Draw Date",
                dataType: DataType.Date,
                isHidden: false,
                isFilterable: true,
                isSortable: false,
                isGrouping: false,
                sortOrder: 0,
                groupOrder: 0,
                columnOrder: 3,
                valueConverter: function (date) { return moment(date).format("DD/MM/YYYY"); },
            },
            {
                name: "estimatedBrandTicketCost",
                title: "Original Cost",
                dataType: DataType.Number,
                isHidden: false,
                isFilterable: true,
                isSortable: false,
                isGrouping: false,
                sortOrder: 0,
                groupOrder: 0,
                columnOrder: 4
            },
            {
                name: "actualBrandTicketCost",
                title: "New Cost",
                dataType: DataType.Number,
                isHidden: false,
                isFilterable: true,
                isSortable: false,
                isGrouping: false,
                sortOrder: 0,
                groupOrder: 0,
                columnOrder: 5
            },
            {
                name: "differenceInCosts",
                title: "Cost Adjustment",
                dataType: DataType.Number,
                isHidden: false,
                isFilterable: true,
                isSortable: false,
                isGrouping: false,
                sortOrder: 0,
                groupOrder: 0,
                columnOrder: 6
            }
        ];
        if (this.isOperatorAdmin() || this.isAdmin()) {
            columns.push({
                name: "differenceInOperatorMargin",
                title: "Operator Margin Adjustment",
                dataType: DataType.Number,
                isHidden: false,
                isFilterable: true,
                isSortable: false,
                isGrouping: false,
                sortOrder: 0,
                groupOrder: 0,
                columnOrder: 7
            });
        }
        if (this.isAdmin()) {
            columns = columns.concat([{
                    name: "differenceInPlatformMargin",
                    title: "Platform Margin Adjustment",
                    dataType: DataType.Number,
                    isHidden: false,
                    isFilterable: true,
                    isSortable: false,
                    isGrouping: false,
                    sortOrder: 0,
                    groupOrder: 0,
                    columnOrder: 8
                },
                {
                    name: "insuranceProfit",
                    title: "Insurance Margin",
                    dataType: DataType.Number,
                    isHidden: false,
                    isFilterable: true,
                    isSortable: false,
                    isGrouping: false,
                    sortOrder: 0,
                    groupOrder: 0,
                    columnOrder: 9
                }]);
        }
        return this.getCommonColumns().concat(columns);
    };
    GlobalBilling.prototype.getClaimsColumns = function () {
        var columns = [
            {
                name: "winningAmountToClaim",
                title: "Winning Claim Full Amount",
                dataType: DataType.Number,
                isHidden: this.isAdmin() ? false : true,
                isFilterable: true,
                isSortable: false,
                isGrouping: false,
                sortOrder: 0,
                groupOrder: 0,
                columnOrder: 4
            },
            {
                name: "insurancePayoutPolicyDeduction",
                title: "Payout Platform Deduction",
                dataType: DataType.Number,
                isHidden: this.isAdmin() ? false : true,
                isFilterable: true,
                isSortable: false,
                isGrouping: false,
                sortOrder: 0,
                groupOrder: 0,
                columnOrder: 5
            },
            {
                name: "winningClaimBrandPayout",
                title: "Actual Payout",
                dataType: DataType.Number,
                isHidden: false,
                isFilterable: true,
                isSortable: false,
                isGrouping: false,
                sortOrder: 0,
                groupOrder: 0,
                columnOrder: 6
            },
            {
                name: "insurerName",
                title: "Insurer",
                dataType: DataType.Default,
                isHidden: false,
                isFilterable: true,
                isSortable: false,
                isGrouping: false,
                sortOrder: 0,
                groupOrder: 0,
                columnOrder: 6
            }
        ];
        return this.getCommonColumns(true).concat(columns);
    };
    GlobalBilling.prototype.isAdmin = function () {
        return this.tokenClient.isSuperAdmin();
    };
    GlobalBilling.prototype.isOperatorAdmin = function () {
        return this.tokenClient.isOperatorAdmin();
    };
    GlobalBilling.prototype.isBrandAdmin = function () {
        return this.tokenClient.isBrandAdmin();
    };
    GlobalBilling.prototype.onItemSelected = function (event) {
        var item = event.detail.item;
        this.router.navigateToRoute(RouterConstants.RouteNames.ManageTicketDraw, {
            id: item.gamePlayerTicketDrawId
        });
    };
    __decorate([
        computedFrom("selectedBrand"),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], GlobalBilling.prototype, "selectedBrandName", null);
    __decorate([
        computedFrom("selectedOperator"),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], GlobalBilling.prototype, "cleanOperatorName", null);
    GlobalBilling = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService, I18N,
            LookupClientService, ConfigurationService,
            BillingClientService, TokenClient, Router, CacheClient])
    ], GlobalBilling);
    return GlobalBilling;
}());
export { GlobalBilling };
